import React from "react";
import SEO from "../SEO";
import config from "../../config";

export default function TheSeaTerms() {
  return (
    <>
    <SEO
      title="Terms of Service — askTheSea"
      description="The terms governing your use of askTheSea's CMC regulatory intelligence agent."
      url={`${config.BaseUrl}/terms`}
      image={`${config.BaseUrl}/assets/logo.png?v=2`}
      noindex
    />
    <section className="page active" id="page-terms">
      <div className="wrap about-hero">
        <div className="eyebrow">Legal</div>
        <h1>Terms of Service</h1>
        <p className="lede">Last updated: July 2026</p>
      </div>

      <div className="wrap">
        <div className="legal-content">
          <section className="tight">
            <h2>Agreement to terms</h2>
            <p>By accessing or using askTheSea ("we," "us," "the service"), you agree to be bound by these Terms of Service. If you do not agree, please do not use the service.</p>
          </section>

          <section className="tight">
            <h2>Description of service</h2>
            <p>askTheSea provides an AI agent that searches publicly available regulatory sources — including agency guidance, notices, meeting minutes, and Q&amp;A documents — and returns answers with citations back to the original source.</p>
          </section>

          <section className="tight">
            <h2>Intellectual property</h2>
            <p>The service, software, content, trademarks, and underlying technology are owned by us, while you retain ownership of content you submit.</p>
          </section>

          <section className="tight">
            <h2>Not regulatory or legal advice</h2>
            <p>askTheSea aggregates and summarizes publicly available regulatory information. It does not provide legal, regulatory, or professional advice, and nothing on this site or generated by the agent should be relied upon as a substitute for consulting a qualified professional or the primary source material.</p>
          </section>

          <section className="tight">
            <h2>Acceptable use</h2>
            <p>You agree not to misuse the service, including by attempting to disrupt its operation, circumvent access limits, or use it for any unlawful purpose. We may suspend or terminate access for use that violates these terms.</p>
          </section>

          <section className="tight">
            <h2>Accounts and payment</h2>
            <p>Some features require creating an account or purchasing points. You are responsible for maintaining the confidentiality of your account and for all activity under it. Fees are described at the point of purchase and are non-refundable except where required by law.</p>
          </section>

          <section className="tight">
            <h2>Disclaimer of warranties</h2>
            <p>The service is provided "as is" without warranties of any kind. We do not guarantee that the agent's answers are complete, accurate, or up to date, and you should verify important information against the cited primary source.</p>
          </section>

          <section className="tight">
            <h2>Limitation of liability</h2>
            <p>To the fullest extent permitted by law, askTheSea is not liable for any indirect, incidental, or consequential damages arising from your use of the service.</p>
          </section>

          <section className="tight">
            <h2>Changes to these terms</h2>
            <p>We may update these Terms of Service from time to time. Material changes will be reflected by an updated "Last updated" date at the top of this page.</p>
          </section>

          <section className="tight">
            <h2>Contact</h2>
            <p>Questions about these terms can be sent to <a href="mailto:info@askthesea.com">info@askthesea.com</a>.</p>
          </section>
        </div>
      </div>
    </section>
    </>
  );
}
